import React, { useEffect, useRef } from "react"
import { gsap, TimelineMax } from "gsap/dist/gsap"
import windowWidthHook from "@hooks/window-width"
import windowHeightHook from "@hooks/window-height"

import Waves from "@assets/svg/waves.inline.svg"

import * as s from "./Interstital.module.scss"

import Logo from "@assets/svg/interLogo.inline.svg"

export const Interstital = ({ onEnd }) => {
  const windowWidth = windowWidthHook()
  const windowHeight = windowHeightHook()

  const tl = new gsap.timeline()
  const _wrapper = useRef(null)

  useEffect(() => {
    tl.to(_wrapper.current, 0.75, {
      translateY: "100%",
    })
      .to(_wrapper.current, 0.4, {
        translateY: "0%",
      })
      .to(_wrapper.current, 1, { translateY: "0%" }, "+=1")
      .to(_wrapper.current, 0.75, {
        translateY: "-100%",
      })
      .eventCallback("onComplete", () => {
        onEnd()
      })
  })
  useEffect(() => {
    const shuffle = elements => {
      const array = [].slice.call(elements)
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    }

    const bubbles = document.getElementsByClassName("bubble")
    const shuffledBubbles = shuffle(bubbles)
    const bubbleTl = new TimelineMax()

    bubbleTl
      .set(shuffledBubbles, { y: 100, scale: 0 })
      .staggerTo(
        shuffledBubbles,
        3,
        { y: -(windowHeight + 200), repeat: -1, scale: 1 },
        0.1,
        "start",
      )
  }, [])

  const randomNumber = (min, max) => {
    if (max === null) {
      max = min
      min = 0
    }
    const position = Math.random() * (max - min) + min

    return Math.floor(position)
  }

  const bubblesArray = new Array(150).fill("bubble")

  return (
    <div className={s.Interstital} ref={_wrapper}>
      <Waves className={s.Interstital__waveWrapper} />

      <div id="bubblesContainer" className={s.Interstital__container}>
        <Logo />

        {bubblesArray.map((e, idx) => {
          return (
            <div
              key={idx}
              id={`bubbles`}
              className={`${s.Interstital__container___bubble} bubble`}
              style={{ right: `${randomNumber(40, windowWidth - 40)}px` }}
            />
          )
        })}
      </div>
    </div>
  )
}
